import { SubmittedEvaluationBlock, SubmittedEvaluationItem } from '../../../../adminv3/types/courseExams';
import React from 'react';
import { ScoreSelector } from './EvaluationScoreSelector';
import './evaluationForm.module.scss';
import { ObservableMap } from 'mobx';
import { observer } from 'mobx-react';

const replace = (array, i, nextitem) =>
    array.map((item, index) => {
        if (i == index) {
            return nextitem;
        } else {
            return item;
        }
    });

const sum = (arr) => arr.reduce((prev, current) => prev + current, 0);

type Props = {
    value: SubmittedEvaluationBlock[];
    onChange: (nextValue: SubmittedEvaluationBlock[]) => any;
    errors: ObservableMap<string, string>;
};
export const EvaluationForm = ({ value, onChange, errors }: Props) => {
    const itemScoreResultArray = value
        .map((block) => block.items.map((item) => item.scoreResult))
        .reduce((current, item) => current.concat(item), [])
        .filter(Boolean);
    const submissionScoreResult = sum(itemScoreResultArray);
    return (
        <div styleName="wrapper" id="evaluation-form">
            {value.map((block, index) => (
                <EvaluationBlockForm
                    key={block.id}
                    value={block}
                    onChange={(nextBrock) => {
                        onChange(replace(value, index, nextBrock));
                    }}
                    errors={errors}
                />
            ))}
            <div styleName="border" />
            <div styleName="submission-total-score-result-wrapper">
                <span styleName="submission-total-score-result-label">合計</span>
                <span styleName="submission-total-score-result" data-submission-total-score-result="body">
                    {submissionScoreResult ? submissionScoreResult : '-'}
                </span>
                <span>点 /100点満点</span>
            </div>
        </div>
    );
};

type BlockFormProps = {
    value: SubmittedEvaluationBlock;
    onChange: (nextValue: SubmittedEvaluationBlock) => any;
    errors: ObservableMap<string, string>;
};
export const EvaluationBlockForm = observer(({ value, onChange, errors }: BlockFormProps) => {
    const itemScoreResultArray = value.items.map((item) => item.scoreResult).filter(Boolean);
    const blockScoreResult = sum(itemScoreResultArray);
    const itemMaxScoreArray = value.items.map((item) => item.maxScore);
    const blockMaxScore = sum(itemMaxScoreArray);
    return (
        <div styleName="evaluation-block" data-evaluation-block-id={value.id}>
            <div styleName="evaluation-block-label-wrapper">
                <div styleName="evaluation-block-label">{value.label}</div>
                <div styleName="evaluation-block-score-wrapper">
                    <span styleName="evaluation-block-score-result" data-evaluation-block-score-result="body">
                        {blockScoreResult ? blockScoreResult : '-'}
                    </span>
                    <span>点 / {blockMaxScore}点満点</span>
                </div>
            </div>
            {value.items.map((item, index) => (
                <EvaluationBlockItemForm
                    key={item.id}
                    value={item}
                    onChange={(nextItem) => {
                        onChange({
                            ...value,
                            items: replace(value.items, index, nextItem),
                        });
                    }}
                    error={errors.get(item.id)}
                />
            ))}
        </div>
    );
});

type BlockItemProps = {
    value: SubmittedEvaluationItem;
    onChange: (nextValue: SubmittedEvaluationItem) => any;
    error: string | null;
};

export const EvaluationBlockItemForm = ({ value, onChange, error }: BlockItemProps) => {
    return (
        <div data-evaluation-block-item-id={value.id}>
            <div styleName="evaluation-block-item">
                <ScoreSelector
                    value={value.scoreResult}
                    onChange={(nextScore) => {
                        onChange({
                            ...value,
                            scoreResult: nextScore,
                        });
                    }}
                    maxScore={value.maxScore}
                />
                <div styleName="evaluation-item-label">{value.label}</div>
            </div>
            {error && (
                <div styleName="evaluation-item-error-message" data-evaluation-item-error-message="body">
                    {error}
                </div>
            )}
        </div>
    );
};
